import dotenv from "dotenv";
import { Configuration, Logger, LogLevel } from "msal";

dotenv.config();

export const API_URL = process.env.REACT_APP_API_URL || "";
export const API_KEY = process.env.REACT_APP_API_KEY || "";
export const GRAPH_API_URL = "https://graph.microsoft.com/v1.0";
export const ALLOWED_USER_GROUPS = process.env.REACT_APP_ALLOWED_USER_GROUPS
  ? process.env.REACT_APP_ALLOWED_USER_GROUPS.split(",")
  : [];
export const ENV = process.env.NODE_ENV === "development" ? "dev" : "";

// Msal Configurations

const authLogger = new Logger(
  (logLevel, message, containsPii) => {
    console.log("[MSAL]", message);
  },
  {
    level: LogLevel.Verbose,
    piiLoggingEnabled: false,
  },
);

export const AUTH_CONFIG: Configuration = {
  auth: {
    authority: process.env.REACT_APP_AUTH_AUTHORITY || "",
    clientId: process.env.REACT_APP_AUTH_CLIENT_ID || "",
    // postLogoutRedirectUri: window.location.origin,
    // redirectUri: window.location.origin,
    postLogoutRedirectUri: process.env.REACT_APP_AUTH_REDIRECT_URL,
    redirectUri: process.env.REACT_APP_AUTH_REDIRECT_URL,
    validateAuthority: true,
    // After being redirected to the "redirectUri" page, should user
    // be redirected back to the Url where their login originated from?
    navigateToLoginRequestUrl: true,
  },
  system: {
    logger: authLogger as Logger,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};
